<template>
  <div>
    <div class="row justify-center">
      <div>
        <h6 class="text-center text-bold q-my-xs">404</h6>
        <h6 class="text-center text-bold q-my-xs">
          Page not Found
        </h6>
        <div class="text-center q-my-xs">
          <q-icon
            name="fas fa-exclamation-triangle"
            size="30px"
            color="red-8"
          />
        </div>
        <h6 class="q-mt-lg text-center text-bold">
          Route To
          <span class="color text-bold" @click="reRoute"> Dashboard</span>
        </h6>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    reRoute() {
      this.$tabs.close();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/quasar.variables.scss";
.color {
  color: $blueColor;
  cursor: pointer;
}
</style>
